module.exports = __webpack_public_path__ + "img/pride_logo_mobile_1.d36d1b6a.png";